// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD0r5WhnbGfUmSIpd6rtlcL0LTXG4r_Mv8",
  authDomain: "pathways1.firebaseapp.com",
  projectId: "pathways1",
  storageBucket: "pathways1.firebasestorage.app",
  messagingSenderId: "317602810337",
  appId: "1:317602810337:web:1ca941fde51bed6476eaa0",
  measurementId: "G-6XLTHRFCNS"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);

export { app, analytics, db, auth };